/**
 *
 * Asynchronously loads the component for AssetsInventoryLogPage
 *
 */

import { lazyLoad } from 'utils/loadable';

export const AssetsInventoryLogPage = lazyLoad(
  () => import('./index'),
  module => module.AssetsInventoryLogPage,
);
